import { createFileRoute } from "@tanstack/react-router";
import { browseDogsDoomscrollRoute } from "@/app-clients/browse-dogs";

export const Route = createFileRoute("/doomscroll")({
    beforeLoad: browseDogsDoomscrollRoute.beforeLoad,
});
